// TO DO LIST
// 1. Map text values to Teamsite

import type { ReactElement } from 'react';
import { useContext } from 'react';
// import { useState, useRef, useContext, useEffect, MouseEvent } from 'react';
import { FormattedMessage } from 'react-intl';
import { format, add } from 'date-fns';
import { useMedia } from 'react-use';
import { MediaQuery } from '../../../styles/mediaQuery';
import AppContext from '../../../utils/createContext';
// import type { ViewportType, AirportType, FlightType } from '../../../utils/types';
import './FareComponent.css';
// import planeImage from '../../../assets/images/aircraft.png';

export function FareComponent(props: any): ReactElement {
  const {
    originAirport,
    // setOriginAirport,
    destinationAirport,
    // setDestinationAirport,
    // flightType,
    // nonstopChecked,
    // setNonstopChecked,
  } = useContext(AppContext);

  const selectedRoute = {
    origin: props.origin,
    destination: props.destination,
    msg: props.msg,
  };
  // Specifying "as keyof typof priceHash" due to error "expression of type string cannot be used to index type 'Object'"
  const routePrice =
    priceHash[
      // props.origin as keyof typeof priceHash + '-' + props.destination as keyof typeof priceHash
      // (`${props.origin as keyof typeof priceHash}-${props.destination}`) as keyof typeof priceHash
      `${props.origin}-${props.destination}` as keyof typeof priceHash
      // `${originAirport.iata_code}-${destinationAirport.iata_code}` as keyof typeof priceHash
    ];
  // Needs DESTINATION to ORIGIN URL difference configured
  // ORIGIN to DESTINATION
  // const departureDate = format(add(Date.now(), { days: 60 }).setDate(1), 'yyyy-MM-dd');
  // const returnDate = format(add(Date.now(), { days: 63 }).setDate(1), 'yyyy-MM-dd');
  // const lowFareCalTo = "https://www.southwest.com/air/low-fare-calendar/select-dates.html?adultPassengersCount=1&lapInfantPassengersCount=0&passengerType=ADULT&returnAirportCode=&currencyCode=USD&originationAirportCode=" + props.origin + "&destinationAirportCode=" + props.destination + "&departureDate=" + departureDate + "&returnDate=" + returnDate + "&tripType=roundtrip&int=rtmaplfc";
  // const lowFareCalTo =
  //   'https://www.southwest.com/air/low-fare-calendar/select-dates.html?adultPassengersCount=1&lapInfantPassengersCount=0&passengerType=ADULT&returnAirportCode=&currencyCode=USD&originationAirportCode={props.origin}&destinationAirportCode={props.destination}&tripType=roundtrip&int=rtmaplfccard';

  // const lowFareCalFrom =
  //  'https://www.southwest.com/air/low-fare-calendar/select-dates.html?adultPassengersCount=1&lapInfantPassengersCount=0&passengerType=ADULT&returnAirportCode=&currencyCode=USD&originationAirportCode=' +
  //  props.destination +
  //  '&destinationAirportCode=' +
  //  props.origin +
  //  '&tripType=roundtrip&int=rtmaplfccard';
  // const LFC = {
  //   url: "",
  //   build: function BuildLfc() {
  //     if ( selectedRoute.origin !== undefined && selectedRoute.destination !== undefined ) {
  //       this.url = lowFareCalFrom;
  //     }
  //     this.url = lowFareCalTo;
  //   }
  // }

  // LFC URL copied from ../MapNavigation/MapNavigation
  const departureDate = format(add(Date.now(), { days: 60 }).setDate(1), 'yyyy-MM-dd');
  const returnDate = format(add(Date.now(), { days: 63 }).setDate(1), 'yyyy-MM-dd');

  const departureDateMobile = format(add(Date.now(), { days: 60 }).setDate(1), 'MM/dd/yyyy');
  const returnDateMobile = format(add(Date.now(), { days: 63 }).setDate(1), 'MM/dd/yyyy');
  const isMobile = useMedia(MediaQuery.XSmall);

  const submitUrl = () => {
    const currentUrl = window.location.href;
    const isMweb = new RegExp('channel=mweb', 'g');
    const isIos = new RegExp('channel=ios', 'g');
    const isAndroid = new RegExp('channel=android', 'g');
    const isIpad = new RegExp('channel=ipad', 'g');
    let result = '';

    if (!originAirport.airport_name || !destinationAirport.airport_name) {
      result = '/route-map/#map-section';
    } else if (isMweb.test(currentUrl) || isMobile) {
      result = `/air/low-fare-calendar/select-dates.html?adultPassengersCount=1&passengerType=ADULT&promoCode=&returnAirportCode=&currencyCode=USD&originationAirportCode=${originAirport.iata_code}&destinationAirportCode=${destinationAirport.iata_code}&departureDate=${departureDate}&returnDate=${returnDate}&tripType=roundtrip&int=rtmaplfc&dummyvar1=${departureDateMobile}&dummyVar2=${returnDateMobile}&useLowFareCalendar=true&lapInfantPassengersCount=0clk=ROUTE_MAP_MWEB_${originAirport.iata_code}_${destinationAirport.iata_code}`;
    } else if (isIos.test(currentUrl) || isAndroid.test(currentUrl) || isIpad.test(currentUrl)) {
      result = `app:airbooking?fromCity=${originAirport.iata_code}&toCity=${destinationAirport.iata_code}&tripType=RT&INT=rtmaplfc&departDate=${departureDate}&returnDate=${returnDate}`;
    } else {
      result = `/air/low-fare-calendar/select-dates.html?adultPassengersCount=1&lapInfantPassengersCount=0&passengerType=ADULT&promoCode=&returnAirportCode=&currencyCode=USD&originationAirportCode=${originAirport.iata_code}&destinationAirportCode=${destinationAirport.iata_code}&departureDate=${departureDate}&returnDate=${returnDate}&tripType=roundtrip&int=rtmaplfc&clk=ROUTE_MAP_${originAirport.iata_code}_${destinationAirport.iata_code}`;
    }
    return result;
  };

  // Import LFMA fare data - Method 1
  // useEffect(() => {
  //  const script = document.createElement('script');
  //  script.src = "../../../assets/scripts/lfma.js";
  //  script.async = true;
  //  document.body.appendChild(script);
  //  return () => {
  //     document.body.removeChild(script);
  //   }
  // }, []);

  function FareMessage() {
    return (
      <div id="routeFare">
        <a
          href={submitUrl()}
          aria-label="Find flights"
          className="cta"
          target="_blank"
          rel="noreferrer"
        >
          <small className="fare--heading">{selectedRoute.msg}</small>
          <div className="fare--price">${routePrice}</div>
        </a>
      </div>
      // <div id="routeFare" className="sky" style={{background: "none"}}>
      //   {/* Plane animation */}
      //   <div className="banner">
      //     <span><small className="fare--heading">{selectedRoute.msg}</small> <strong>${routePrice}</strong></span>
      //   </div>
      //   <img src={planeImage}></img>
      // </div>
    );
  }

  function NoFareMessage() {
    return (
      <div id="routeFare" style={{ padding: '0.7813rem 1.25rem', marginTop: '3px' }}>
        <a
          href={submitUrl()}
          aria-label="View fares on the Low Fare Calendar"
          className="cta"
          target="_blank"
          rel="noreferrer"
          style={{ textDecoration: 'underline' }}
        >
          <small className="fare--heading">
            <FormattedMessage
              id="map-info-nofare-message"
              description="Fare information unavailable"
              defaultMessage="View fares on the Low Fare Calendar"
            />
          </small>
        </a>
      </div>
    );
  }

  function SelectionMessage() {
    return (
      <div id="routeFare" style={{ padding: '0.7813rem 1.25rem', marginTop: '3px' }}>
        <small className="fare--heading">
          <FormattedMessage
            id="map-info-select-destination-message"
            description="Select a destination"
            defaultMessage="Select a destination"
          />
        </small>
      </div>
    );
  }
  function Message() {
    if (routePrice !== undefined) {
      return <FareMessage />;
    }
    if (
      selectedRoute.origin &&
      selectedRoute.destination !== undefined &&
      routePrice === undefined
    ) {
      return <NoFareMessage />;
    }
    return <SelectionMessage />;
  }

  // useEffect(() => {
  //   if (props.origin && props.destination) {
  //     // Specifying "as keyof typof priceHash" due to error "expression of type string cannot be used to index type 'Object'"
  //     const routePrice = priceHash[props.origin as keyof typeof priceHash + "-" + props.destination as keyof typeof priceHash];
  //     alert("O&D sent. Price: " + routePrice);
  //     if ( routePrice !== undefined ) {

  //    }

  //   } else {
  //     alert("O&D not sent");
  //   }
  // }, [props.origin, props.destination]);

  return <Message />;
}
